<template>
  <div>
    <el-form :model="data" label-position="top">
      <template v-if="data.type === 'start' || data.type==='node'">
        <el-form-item label="节点名称">
          <el-input v-model="data.name" @change="handleUpdate" />
        </el-form-item>
        <!--      <el-form-item>-->
        <!--        <el-radio-group v-model="config_type">-->
        <!--          <el-radio-button label="basic">基础属性</el-radio-button>-->
        <!--          <el-radio-button label="extra">更多属性</el-radio-button>-->
        <!--        </el-radio-group>-->
        <!--      </el-form-item>-->
        <el-form-item v-if="data.type==='node'" label="流转规则">
          <el-select v-model="data.approval" style="width: 100%;" value="0" @change="handleUpdate">
            <el-option label="任意负责人提交后进入下一节点" :value="0" />
            <el-option label="所有负责人提交后进入下一节点" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="data.type==='node'" label="审批意见">
          <el-switch v-model="data.comment" :active-value="1" :inactive-value="0" @change="handleUpdate" />
        </el-form-item>
        <el-form-item v-if="data.type==='node'" label="负责人">
          <member-list-pane v-model="data.members" :data="data.members" :tabs="['department','user', 'role', 'dynamic_flow']" @input="handleUpdate" />
        </el-form-item>

        <el-form-item label="字段权限">
          <widgets-check-group v-model="data.widgets" :widgets="widgets" />
        </el-form-item>
      </template>
      <template v-else-if="data.type === 'line'">
        <el-form-item label="流转条件">
          <el-select v-model="condition_option" style="width: 100%;" value="0" @change="handConditionOptionChange">
            <el-option label="自定义条件" :value="0" />
            <el-option label="使用Else条件" :value="1" />
          </el-select>
          <div class="condition">
            <p v-if="condition_option === 0">当数据满足流转条件时，进入这条连接线下的节点；不添加流转条件时，所有数据都会进入这条连接线下的节点。</p>
            <p v-else>当数据不满足同级的其他流转条件时，进入这条连接线下的节点。</p>
          </div>
        </el-form-item>
        <div v-if="condition_option === 0 && typeof condition.cond !== 'undefined' && condition.cond.length > 0" class="condition_item">
          <el-row>
            <el-col style="margin-right: 10px;" :span="14">
              <el-form-item>
                <el-select v-model="condition.cond[0].field">
                  <el-option v-for="_widget in widgets" :key="_widget.key" :label="_widget.name" :value="_widget.key" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item>
                <el-select v-model="condition.cond[0].method">
                  <el-option label="等于" value="eq" />
                  <el-option label="不等于" value="ne" />
                  <el-option label="大于等于" value="ge" />
                  <el-option label="小于等于" value="le" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item v-model="condition.cond[0].value">
              <template v-if="selected_widget.type === 'input' || selected_widget.type === 'textarea'">
                <el-input v-model="condition.cond[0].value[0]" placeholder="请输入" />
              </template>
              <template v-else-if="selected_widget.type === 'select'">
                <el-select v-model="condition.cond[0].value[0]">
                  <el-option v-for="_option in selected_widget.options.options" :key="_option.value" :label="_option.value" :value="_option.value" />
                </el-select>
              </template>
            </el-form-item>
          </el-row>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
import MemberListPane from './MemberListPane'
import WidgetsCheckGroup from './WidgetsCheckGroup'
export default {
  components: {
    MemberListPane,
    WidgetsCheckGroup,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    widgets: {
      type: Array,
      default: () => {[]},
    },
  },
  data() {
    return {
      innerData: this.data,
      condition_option: 1,
      condition: {},
      config_type: 'basic',
      // define the default value
      // define options
      options: [],
    }
  },
  computed: {
    selected_widget() {
      if (typeof this.condition.cond === 'undefined' || this.condition.cond[0].field === '') {
        return {}

      }
      return this.widgets.filter(item => item.key === this.condition.cond[0].field)[0]
    },
  },
  watch: {
    'data.widgets': {
      handler(val, oldVal) {
        console.log('data.widgets changed', val)
        this.$emit('update:data', this.data)
      },
      deep: true,
    },
    condition: {
      deep: true,
      handler(val) {
        console.log('condition change', val)
        this.data.condition = val
        this.$emit('update:data', this.data)
      },
    },
    data() {
      if (this.data.type === 'line') {
        if (typeof this.data.condition !== 'undefined') {
          this.condition_option = 0
          console.log('condition', this.data.condition)
          this.condition = this.data.condition
        } else {
          this.condition_option = 1

        }

      }

    },
  },
  created() {
    console.log('node config created', this.data, this.innerData)
  },
  methods: {

    handConditionOptionChange(val) {
      if (val === 0) {
        this.condition = {
          cond: [
            {
              'method': 'eq',
              'value': [
              ],
              'field': '',
            },
          ],
          rel: 'and',
        }
      } else {
        this.condition = {isElse: true}
      }
    },
    handleUpdate() {
      console.log('update')
      this.$emit('update:data', this.data)
    },


  },
}
</script>
<style lang="scss">
.condition {
  font-size: 12px;
  line-height: 16px;
  margin-top: 10px;
}

.radioDiv {
  margin: 0 auto;
  width: auto;
  text-align: left;
  display: table;
}

.condition_item {
  .el-form-item {
    border-bottom: 0 !important;
  }
}
</style>
